import { FileUploadDialog } from '../fileupload/FileUploadDialog';
import * as React from 'react';
import { WActionButton } from './WActionButton';

interface WUploadButtonProps extends React.ClassAttributes<any> {
    tooltip?: string;
    label: string;
    disabled?: boolean;
    style?: string;
    styleProps?: React.CSSProperties;
    divStyle?: React.CSSProperties;
    indicatorValue?: number;
    indicatorChar?: string;
    indicatorColor?: string;
    indicatorFullNumber?: boolean;
    sidetext?: string;
    insideText?: string | JSX.Element;
    insideLeftMargin?: number;
    place?: string;
    onDataLoaded(data: string): void;
}

interface WUploadButtonState extends React.ClassAttributes<any> {
    isLoading: boolean;
}

 export class WUploadButton extends React.Component<WUploadButtonProps, WUploadButtonState> {

    constructor(props: any) {
        super(props);
        this.state = {
            isLoading: false
        };
        this.onDataLoaded = this.onDataLoaded.bind(this);
    }

    private refUpload: any;

    onDataLoaded(data: string): void {
        this.setState({ isLoading: false }, () => this.props.onDataLoaded(data));
    }

    render(): JSX.Element {
        const disabled: boolean = this.props.disabled || this.state.isLoading;
        const styleProps: React.CSSProperties = {
            ...(disabled ? { backgroundColor: 'lightgray', cursor: 'not-allowed' } : {}),
            ...(this.props.styleProps || {})
        };

        return <>
            <WActionButton
                label={this.props.label}
                tooltip={this.props.tooltip}
                action='import'
                disabled={disabled}
                style={this.props.style}
                styleProps={styleProps}
                divStyle={this.props.divStyle}
                sidetext={this.props.sidetext}
                insideText={this.props.insideText}
                insideLeftMargin={this.props.insideLeftMargin}
                place={this.props.place}
                onAction={() => this.refUpload && this.refUpload.click()}
            />
            <FileUploadDialog
                getRef={(refUpload: any) => refUpload && !this.refUpload && (this.refUpload = refUpload) }
                isHidden
                onDataLoaded={this.onDataLoaded}
                onDataSelected={() => this.setState({ isLoading: true })}
            />
        </>;
    }
}
